import cookies from '@/utils/cookies';

export const checkOnboardingWithMigration = (cookieName, localStorageKey, config) => {
  // Check cookies first (new system)
  const cookieValue = cookies.getCookie(cookieName);
  
  if (cookieValue) {
    return true;
  }
  
  // If not in cookies, check localStorage (grace period for existing users)
  const localStorageValue = localStorage.getItem(localStorageKey);
  
  if (localStorageValue) {
    // Migrate to cookies for future use
    cookies.setCookie({
      name: cookieName,
      value: 'true',
      ...config,
    });
    return true;
  }
  
  return false;
};